export const GET_THEMES = "get_themes";
export const CREATE_THEME = "create_theme";
export const EDIT_THEME = "edit_theme";
export const START_LOADING = "start_loading";
export const DELETE_THEME = "delete_theme";
export const STOP_LOADING = "stop_loading";
export const ERROR = "error";
